export default function Tentang() {
  return (
    <div className="p-6 max-w-2xl">
      <h1 className="text-xl font-bold text-gray-800 dark:text-white mb-4">Tentang CERAH Pedia</h1>
      <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 p-6 space-y-4 text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
        <p>
          <strong className="text-cerah-navy dark:text-white">CERAH Pedia</strong> adalah platform manajemen pengetahuan internal
          organisasi CERAH — pusat kolaborasi, dokumentasi, dan berbagi informasi untuk mendukung misi transisi energi berkeadilan.
        </p>
        <p>
          Platform ini menyediakan akses terpusat ke dokumen SOP, laporan program, materi literasi, infografik,
          direktori kontak, serta kanal video dari pimpinan dan manajemen CERAH.
        </p>
        <div className="border-t border-gray-100 dark:border-gray-700 pt-4">
          <p className="text-xs text-gray-400">Versi 1.0.0 · POC Build</p>
        </div>
      </div>
    </div>
  )
}
